import React from 'react';
import { Outlet } from 'react-router-dom';

const AcademicCreateVacancy: React.FC = () => <Outlet />;

export default AcademicCreateVacancy;
